import React, { useEffect, useReducer, useState } from 'react';
import colors from '../../assets/styles/colors';
import Copyright from '../../components/Copyright';
import FormSteps from '../../components/FormSteps';
import Loader from '../../components/Loader';
import { H4, P } from '../../components/Typography/styles';
import {
  InternationalOperationsContainer,
  InternationalOperationsWrapper,
  InternationalOperationsHeader,
  InternationalOperationsHeaderTitle,
  InternationalOperationsHeaderArea,
  InternationalOperationsContent
} from './styles';
import { internationalOperationsSteps } from '../../helpers/enum';
import { InternationalOperationsContext } from '../../store';
import internationalOperationsReducer from '../../store/InternationalOperations';
import INITIAL_STATE_INTERNATIONAL_OPERATIONS from '../../store/InternationalOperations/state';
import Operations from './Operations';
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import { useHistory, useLocation } from 'react-router-dom';
import PoliticallyExposedPerson from './PoliticallyExposedPerson';
import { default as InternationalOperationsTypes } from '../../store/InternationalOperations/types';

const InternationalOperationsPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [internationalOperations, setInternationalOperations] = useReducer(internationalOperationsReducer, INITIAL_STATE_INTERNATIONAL_OPERATIONS);
  const [activeStep, setActiveStep] = useState(internationalOperationsSteps.INTERNATIONAL_OPERATIONS);
  const [lastStep, setLastStep] = useState(internationalOperationsSteps.DEFAULT);

  async function initializeStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);

      setInternationalOperations({
        type: InternationalOperationsTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      setInternationalOperations({
        type: InternationalOperationsTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })

      setInternationalOperations({
        type: InternationalOperationsTypes.SET_OPERATIONS,
        operations: {
          monedaExtranjera:{value:solicitationResponse.data.credito.productosMonedaExtranjera } ,
          productMonedaExtranjera: {value:solicitationResponse.data.credito.productosMonedaExtranjera},
          transationType: solicitationResponse.data.personaExpuestaPoliticamente.familiares,
          cual: solicitationResponse.data.credito.descripcionTransaccion,
          banco: solicitationResponse.data.credito.bancoMonedaExtranjera,
          numProducto: solicitationResponse.data.credito.numeroProductoMonedaExtranjera,
          tipoProducto: solicitationResponse.data.credito.tipoProductoMonedaExtranjera,
          pais: solicitationResponse.data.credito.paisMonedaExtranjera,
          ciudad: solicitationResponse.data.credito.ciudadMonedaExtranjera,
          montoOperacional: solicitationResponse.data.credito.montoOperacionMonedaExtranjera,
          moneda: solicitationResponse.data.credito.moneda,
          transationType: {nombre:solicitationResponse.data.credito.transaccionMonedaExtranjera } 
        }
      });
      setInternationalOperations({
        type: InternationalOperationsTypes.SET_POLITICALLY_EXPOSED_PERSON,
        politicallyExposedPerson: {
          publicStaff: { value: solicitationResponse.data.personaExpuestaPoliticamente.funcionarioPublico },
          managePublicResources: {value: solicitationResponse.data.personaExpuestaPoliticamente.manejoRecursosPublicos },
          politicallyExposed: {value: solicitationResponse.data.personaExpuestaPoliticamente.expuestoPoliticamente },
          politicallyExposedRelatives: {value: solicitationResponse.data.personaExpuestaPoliticamente.familiarExpuestoPoliticamente },
          fecha: solicitationResponse.data.personaExpuestaPoliticamente.fechaVinculacion,
        }
      });
      /*setInternationalOperations({
        type: InternationalOperationsTypes.SET_RELATIVES,
        relatives: solicitationResponse.data.personaExpuestaPoliticamente.familiares
      });*/
      setIsLoading(false);
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializeStateComponent();
  }, [])

  return (
    <InternationalOperationsContainer id="international-operations-page">
      {isLoading ? <Loader /> : (
        <>
          <InternationalOperationsWrapper>
            <InternationalOperationsHeader>
              <InternationalOperationsHeaderTitle>Clientes</InternationalOperationsHeaderTitle>
              <InternationalOperationsHeaderArea>
                <H4 color={colors.textPrimary}>Operaciones internacionales y PEPS</H4>
                <P bold color={colors.textPrimary}>
                  {internationalOperations.solicitation?.cliente.nombres} {internationalOperations.credit?.cliente.tipoIdentificacion.toUpperCase()}. {internationalOperations.credit?.cliente.identificacion}
                </P>
              </InternationalOperationsHeaderArea>
            </InternationalOperationsHeader>

            <InternationalOperationsContent id="global-debt-steps">
              <FormSteps lastStep={lastStep} steps={[
                {number: internationalOperationsSteps.INTERNATIONAL_OPERATIONS, label: 'Operaciones internacionales'},
                /*{number: internationalOperationsSteps.POLITICALLY_EXPOSED_PERSON, label: 'Persona expuesta politicamente '}*/
              ]} />

              <InternationalOperationsContext.Provider value={{ internationalOperations, setInternationalOperations }}>
                {activeStep === internationalOperationsSteps.INTERNATIONAL_OPERATIONS && (
                  <Operations setActiveStep={setActiveStep} setLastStep={setLastStep} />
                )}

                {activeStep === internationalOperationsSteps.POLITICALLY_EXPOSED_PERSON && (
                  <PoliticallyExposedPerson setActiveStep={setActiveStep} setLastStep={setLastStep} />
                )}
              </InternationalOperationsContext.Provider>
            </InternationalOperationsContent>
          </InternationalOperationsWrapper>
          <Copyright />
        </>
      )}
    </InternationalOperationsContainer>
  )
}

export default InternationalOperationsPage;
